import styled from "styled-components/macro";

export const Spacer = styled.div<{ height: number }>`
  height: ${(props) => props.height}px;
`;
